module.exports = __webpack_public_path__ + "img/settled.076166b6.png";